document.querySelectorAll('.nb-b2b-page').forEach((root) => {
  // reveal on enter
    const rvIO=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting)e.target.classList.add('nb-b2b-in')})},{threshold:.14});
    root.querySelectorAll('.nb-b2b-rv').forEach(el=>rvIO.observe(el));
  
    // active rail
    const rail=[...root.querySelectorAll('.nb-b2b-rail a')];
    const secIO=new IntersectionObserver((es)=>{es.forEach(e=>{
      if(e.isIntersecting){const n=e.target.dataset.n;rail.forEach(a=>a.classList.toggle('nb-b2b-active',a.dataset.r===n));}
    })},{threshold:.5});
    root.querySelectorAll('.nb-b2b-slide').forEach(s=>secIO.observe(s));
});
